import { z } from "zod";

import { Shifts } from "../features/monthlynonbh/types";
import { validateShift } from "../features/monthlynonbh/utils/validateShift";

export const fireExtinguisherSchema = z
  .object({
    extinguisherChecked: z.string().trim().min(1, "Required"),
    extinguisherIssues: z.string().trim().min(1, "Required"),
    extinguisherIssueDescription: z.string().optional(),
  })
  .superRefine(
    (
      { extinguisherIssues, extinguisherIssueDescription },
      refinementContext,
    ) => {
      if (extinguisherIssues === "No") {
        if (
          extinguisherIssueDescription === undefined ||
          extinguisherIssueDescription.trim() === ""
        ) {
          refinementContext.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Required",
            path: ["extinguisherIssueDescription"],
          });
        }
      }
    },
  );

export const smokeDetectorSchema = z
  .object({
    smokeDetectorChecked: z.string().trim().min(1, "Required"),
    smokeDetectorIssues: z.string().trim().min(1, "Required"),
    smokeDetectorIssueDescription: z.string().optional(),
  })
  .superRefine(
    (
      { smokeDetectorIssues, smokeDetectorIssueDescription },
      refinementContext,
    ) => {
      if (smokeDetectorIssues === "No") {
        if ((smokeDetectorIssueDescription ?? "").trim() === "") {
          refinementContext.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Required",
            path: ["smokeDetectorIssueDescription"],
          });
        }
      }
    },
  );

export const egressLightSchema = z
  .object({
    egressLightChecked: z.string().trim().min(1, "Required"),
    egressLightIssues: z.string().trim().min(1, "Required"),
    egressLightIssueDescription: z.string().optional(),
  })
  .superRefine(
    ({ egressLightIssues, egressLightIssueDescription }, refinementContext) => {
      if (egressLightIssues === "No") {
        if (
          egressLightIssueDescription === undefined ||
          egressLightIssueDescription.trim() === ""
        ) {
          refinementContext.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Required",
            path: ["egressLightIssueDescription"],
          });
        }
      }
    },
  );

export const fireDrillSchema = z.object({
  supervisingStaff: z.string().min(1, "Invalid staff"),
  location: z.string().min(1, "Invalid location"),
  auditDate: z.coerce.date().refine((date) => date.getTime() < Date.now(), {
    message: "Date cannot be in the future",
  }),
});

export const validateShiftSchema = z
  .object({
    auditDate: z.coerce.date(),
    shift: z.nativeEnum(Shifts),
  })
  .refine((data) => validateShift(data.auditDate, data.shift), {
    message: "Start time outside of shift.",
  });
